import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { InputSearch } from "components/Atomos/Form/Elements/InputSearch";
import { getEssentialServicesGeojsonRequest } from "store/modules/ouvidoria/pontosessenciais/actions/getEssentialServicesGeojson";
import { Box, VStack, Text, Skeleton, Alert, HStack } from "@chakra-ui/react";
import { useTypedSelector } from "store/hooks";
import { TextGray } from "components/Atomos/Texts/TextGray";
import { IconButtonGray } from "components/Atomos/Buttons/IconButtonGray";
import { RiArrowRightLine } from "react-icons/ri";
import { ToLatLngBound } from "utils/map/converters/BoundConverter";
import { useMap } from "react-leaflet";

export function TabPontosEssenciais() {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const map = useMap();

  useEffect(() => {
    dispatch(getEssentialServicesGeojsonRequest({ search }));
  }, [search]);

  const {
    isRequesting: loadingEssentialServices,
    successPayload: essentialServices
  } = useTypedSelector(
    (state) => state.ouvidoria.pontosessenciais.getEssentialServicesGeojson
  );

  return (
    <Box>
      <InputSearch size="sm" onChangeValue={setSearch} />
      {!loadingEssentialServices && essentialServices?.features.length === 0 && (
        <Alert status="info" fontSize="sm" mt="2">
          Nenhum ponto essencial encontrado.
        </Alert>
      )}
      {loadingEssentialServices ? (
        <VStack pt="4" spacing={8}>
          {Array(4)
            .fill(0)
            .map((_, i) => (
              <VStack key={i} w="full">
                <Skeleton height="20px" w="full" />
                <Skeleton height="40px" w="full" />
              </VStack>
            ))}
        </VStack>
      ) : (
        <Box>
          {essentialServices?.features?.map((feature) => {
            const prop = feature.properties;
            return (
              <Box
                key={feature.properties.id}
                w="full"
                borderBottom="thin"
                borderBottomStyle="solid"
                borderBottomColor={"gray.100"}
                px="2"
              >
                <HStack>
                  <VStack
                    p={2}
                    spacing={0}
                    justify="flex-start"
                    align="flex-start"
                  >
                    <Text fontSize="md" fontWeight="medium">
                      {prop.titulo}
                    </Text>

                    <TextGray fontSize="sm" noOfLines={2}>
                      Endereço: {prop.endereco.logradouro},{" "}
                      {prop.endereco.bairro} - {prop.endereco.municipio}
                    </TextGray>
                  </VStack>
                  <Box>
                    <IconButtonGray
                      onClick={() => {
                        if (feature.bbox) {
                          map.flyToBounds(ToLatLngBound(feature.bbox), {
                            animate: false,
                            maxZoom: 19
                          });
                        }
                      }}
                      size="sm"
                      icon={<RiArrowRightLine />}
                      aria-label="Selecionar zoneamento"
                    />
                  </Box>
                </HStack>
              </Box>
            );
          })}
        </Box>
      )}
    </Box>
  );
}
